import { c as _c } from "react/compiler-runtime";
import React from "react";
import styles from "./GiftCards.module.scss";
import { GiftCardItem, GiftCardItemProps } from "./GiftCardItem";
export const GiftCards: React.FC<{
  giftcards: Array<Omit<GiftCardItemProps, "locale" | "currency"> & {
    _key: any;
  }>;
  locale?: string | null;
  currency?: string | null;
}> = t0 => {
  const $ = _c(6);
  const {
    giftcards,
    locale,
    currency
  } = t0;
  let t1;
  if ($[0] !== currency || $[1] !== giftcards || $[2] !== locale) {
    t1 = giftcards && giftcards.map(t2 => {
      const {
        _key,
        title,
        price,
        image,
        alt,
        links
      } = t2;
      return <GiftCardItem key={_key} title={title} price={price} image={image} alt={alt} links={links} locale={locale} currency={currency} />;
    });
    $[0] = currency;
    $[1] = giftcards;
    $[2] = locale;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t1) {
    t2 = <div className={styles.giftcards}>{t1}</div>;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};